'use strict';

// All polyfills (if not marked otherwise) are taken from ..
// - https://developer.mozilla.org/de/docs/Web/JavaScript/Reference

// Math.trunc polyfill for Internet Explorer
if (!Math.trunc) {
    Math.trunc = function (v) {
        v = +v;
        return v - (v % 1) || (!isFinite(v) || v === 0 ? v : v < 0 ? -0 : 0);
    };
}

if (!Math.sign) {
    Math.sign = function (number) {
        return number < 0 ? -1 : 1;
    };
}

if (!Math.log10) {
    Math.log10 = function (x) {
        return Math.log(x) * Math.LOG10E;
    };
}

if (!String.prototype.repeat) {
    String.prototype.repeat = function (count) {
        'use strict';
        if (this == null) {
            throw new TypeError("can't convert " + this + ' to object');
        }
        var str = '' + this;
        count = +count;
        if (count != count) {
            count = 0;
        }
        if (count < 0) {
            throw new RangeError('repeat count must be non-negative');
        }
        if (count == Infinity) {
            throw new RangeError('repeat count must be less than infinity');
        }
        count = Math.floor(count);
        if (str.length == 0 || count == 0) {
            return '';
        }
        // Ensuring count is a 31-bit integer allows us to heavily optimize the
        // main part. But anyway, most current (August 2014) browsers can't handle
        // strings 1 << 28 chars or longer, so:
        if (str.length * count >= 1 << 28) {
            throw new RangeError('repeat count must not overflow maximum string size');
        }
        var rpt = '';
        for (var i = 0; i < count; i++) {
            rpt += str;
        }
        return rpt;
    };
}
module.exports = {};
